export default class CapitalizationOfEarning {
  constructor({
    afterTaxFreeCashFlow,
    afterTaxNetCashFlowCapitalizationRate,
    preTaxFreeCashFlow,
    preTaxNetCashFlowCapitalizationRate,
    ebit,
    preTaxNetIncomeCapitalizationRate
  }) {
    this.afterTaxFreeCashFlow = afterTaxFreeCashFlow
    this.afterTaxNetCashFlowCapitalizationRate = afterTaxNetCashFlowCapitalizationRate
    this.preTaxFreeCashFlow = preTaxFreeCashFlow
    this.preTaxNetCashFlowCapitalizationRate = preTaxNetCashFlowCapitalizationRate
    this.ebit = ebit
    this.preTaxNetIncomeCapitalizationRate = preTaxNetIncomeCapitalizationRate
  }

  get afterTaxCapitalizedEarningsOfSubjectCompany() {
    if (this.afterTaxNetCashFlowCapitalizationRate === 0) return 0

    return (this.afterTaxFreeCashFlow / this.afterTaxNetCashFlowCapitalizationRate) * 100
  }

  get beforeTaxCapitalizedEarningsOfSubjectCompany() {
    if (this.preTaxNetCashFlowCapitalizationRate === 0) return 0

    return (this.preTaxFreeCashFlow / this.preTaxNetCashFlowCapitalizationRate) * 100
  }

  get preTaxCapitalizedEarningsOfSubjectCompany() {
    if (this.preTaxNetIncomeCapitalizationRate === 0) return 0

    return (this.ebit / this.preTaxNetIncomeCapitalizationRate) * 100
  }
}
